import { Middleware } from "redux";
import ApplicationLogger from '../utils/logger';

export const logger: Middleware = (store) => (next) => (action) => {
  if (process.env.NODE_ENV !== "production") {
    ApplicationLogger.debug('iChannel', 'Redux Middleware', action);
  }
  return next(action);
};
